
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-7007ce62\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader!./modalCardNews.scss")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./modalCardNews.ts"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7007ce62\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./modalCardNews.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/home/modals/modalCardNews/modalCardNews.vue.html
// module id = ppjU
// module chunks = 2